import { FulfillmentBoardWrapper } from '../../components'

export default function MarketplaceOrdersPage() {
  return <FulfillmentBoardWrapper />
}
